/**
 * TikTok Pixel Integration
 * Documentation: https://ads.tiktok.com/marketing_api/docs?id=1739585700402178
 */

export function initTikTokPixel({ pixelId, options = {} }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    ttq.load(pixelId, options);
    ttq.page();
}

export function dispatchTikTokViewContent({ data = null, options = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    ttq.track('ViewContent', data, options);
}

export function dispatchTikTokClickButton({ data = null, options = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    ttq.page();
    ttq.track('ClickButton', data, options);
}

export function dispatchTikTokInitiateCheckout({ data = null, options = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    ttq.page();
    ttq.track('InitiateCheckout', data, options);
}

export function dispatchTikTokAddPaymentInfo({ data = null, options = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    ttq.page();
    ttq.track('AddPaymentInfo', data, options);
}

export function dispatchTikTokCompletePayment({ data = null, options = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }

    ttq.page();
    ttq.track('Purchase', data, options);
}

export function dispatchTikTokPlaceAnOrder({ data = null, options = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    ttq.page();
    ttq.track('PlaceAnOrder', data, options);
}

export function identifyTikTokUser({ email = null, phone = null, externalId = null }) {
    if (typeof ttq === 'undefined') {
        console.error('TikTok Pixel not loaded');
        return;
    }
    
    const userData = {};
    
    if (email) {
        email = email.trim();
        email = email.toLowerCase();
        userData.email = email;
    }
    
    if (phone) {
        userData.phone_number = phone;
    }
    
    if (externalId) {
        externalId = externalId.trim();

        userData.external_id = externalId;
    }
    
    if (Object.keys(userData).length > 0) {
        ttq.identify(userData);
    }
}
